import { property, remote, supertypeClass } from '@haventech/amorphic';
import { Everything } from '@hit/amorphic-types';
import { Policy } from './Policy';
import { Entitlement, UserPrincipal } from '../agent/UserPrincipal';
import { Agent } from './Agent';
import { AgentProxy } from '../agent/AgentProxy';
import { OpsProxy } from '../agent/OpsProxy';

@supertypeClass({ toClient: true, toServer: true })
export class PolicyFollower extends Everything {
  @property({ getType: () => Policy })
  policy: Policy;

  @property({ getType: () => Entitlement })
  followerType: Entitlement;

  @property()
  followerId: string;

  constructor() {
    super();
  }

  static new(policy: Policy, follower: Agent | AgentProxy | OpsProxy, entitlement: Entitlement) {
    return new PolicyFollower().init(policy, follower, entitlement);
  }

  init(policy: Policy, follower: Agent | AgentProxy | OpsProxy, entitlement?: Entitlement) {
    this.policy = policy;
    this.followerId = follower._id;
    this.followerType = entitlement;

    return this;
  }

  async getFollower(): Promise<AgentProxy | OpsProxy | Agent> {
    switch (this.followerType) {
      case Entitlement.AGENT_PROXY: {
        return AgentProxy.persistorFetchById(this.followerId, { session: this.amorphic });
      }
      case Entitlement.OPS_PROXY: {
        return OpsProxy.persistorFetchById(this.followerId, { session: this.amorphic });
      }
      // Entitlement.AGENT and Entitlement.DUAL_ROLE
      default: {
        return this.followerId ? Agent.persistorFetchById(this.followerId, { session: this.amorphic }) : null;
      }
    }
  }

  /**
   * Return true, if the follower is the currently logged in user.
   * @param principal
   */
  public isLoggedin(principal: UserPrincipal): boolean {
    return principal.user._id === this.followerId;
  }
}
